export default __webpack_public_path__ + "static/Fizjomedica-logo-5db881876523fbafc8af6ad698910b49.svg";